import React, { Fragment, useEffect, useState } from 'react'
import { Button, Card } from 'react-bootstrap'
import subs from '../../Assets/Images/subs.png'
import { FaCheck } from 'react-icons/fa6'
import useSiteInfo from '../../Hooks/SiteInfo/useSiteInfo'
import { postStrip } from '../../Services/stripServices'
import { useStripe, useElements, PaymentElement, Elements } from '@stripe/react-stripe-js';
import CheckoutForm from '../Strip/CheckoutForm'
import { loadStripe } from '@stripe/stripe-js';
import StripComp from '../Strip'
import SubscriptionStripComp from '../Strip/SubsFormIndex'
import useBooks from '../../Hooks/Books/useBooks'
import { useSelector } from 'react-redux'
import { Link } from 'react-router-dom'


const stripePromise = loadStripe('pk_test_51Lcpz9JaQ38yVOQoH2XbSGeAlLyiVBavaO7AxnBYt4p8cr5pXqQvNXNBlzDnAQDIvjCgeWwCT9zJIR4vft02hLYm00kV1gveR9');


const SubscriptionDetail = () => {

    const {
        handleSiteInfo,
        siteInfo,
        months,
        handleSubmit,
        activeyears,
        handleMonths
    } = useSiteInfo();

    const {
        checkSubs,
        token
    } = useBooks();




    return (
        <Fragment>

            <div className="container my-5">
                <div className="row my-5 justify-content-between">
                    <div className="col-lg-6">
                        <h2 className='s-38 fw-600'>Subscribe now for a Monthly dose of wellness & cultural treasures.</h2>

                        <h3>Subscription Fees : ${siteInfo?.subscriptionFees ? siteInfo?.subscriptionFees : ""}</h3>

                        <h4>Total : ${siteInfo?.subscriptionFees ? siteInfo?.subscriptionFees * activeyears?.length : ""}</h4>

                        <div className="row g-2">
                            {
                                months?.map((item, i) => {
                                    return (
                                        <>
                                            <div className="col-auto">
                                                <div onClick={() => handleMonths(item?.name)} className={`${activeyears?.find((itemm, indexx) => itemm == item?.name) ? 'bg-danger text-white' : "bg-light"} text-capitalize subscription-month  rounded-2`}>
                                                    {item?.name}
                                                </div>
                                            </div >
                                        </>
                                    )
                                })
                            }
                        </div>


                    </div>

                    <div className="col-lg-4">
                        <Card className='border-0 rounded-4 overflow-hidden'>
                            <Card.Img variant="top" src={siteInfo?.imageUrl + '/' + siteInfo?.subscribeBanner} />
                            <Card.Body className='bg-light '>
                                <Card.Text>
                                    <h5 className='s-18'>
                                        Subscription Box will include:
                                    </h5>

                                    <p className='s-14'><FaCheck size={14} className='me-1' />
                                        {checkSubs?.data ? JSON.parse(checkSubs.data).join(", ") : ""}
                                    </p>

                                </Card.Text>
                            </Card.Body>
                        </Card>


                        <div className="mt-3 p-3 shadow-sm">

                            {
                                token ? <SubscriptionStripComp /> : <><Button as={Link} to={"/login"} className='btn btn-danger w-100'>Login To Subscribe</Button></>
                            }
                        </div>


                    </div>
                </div>
            </div>

        </Fragment >
    )
}

export default SubscriptionDetail